import { render } from "./DashboardView.vue?vue&type=template&id=5c76549d&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"

import "./DashboardView.vue?vue&type=style&index=0&id=5c76549d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\diego\\source\\repos\\PoligeoDocumenti\\PoligeoDocumenti\\poligeo-documenti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c76549d"]])

export default __exports__